import { cn } from '@/lib/utils';

/** Table/list link to a product, machine, or location — matches Products list rows. */
export const entityLinkClassName = 'font-medium hover:underline';

export function entityLinkClass(...extra: Array<string | false | null | undefined>): string {
  return cn(entityLinkClassName, ...extra);
}
